module.exports = __webpack_public_path__ + "media/bacteria-bounce-1.f66d2f8e.mp3";